<template>
  <div>
      <mheade></mheade>
      <div style="width:1300px;margin:0 auto;">
              <!-- 表单内容 -->
         <div class="card">   
             <p class="mt-2 font">
                <img src="../../../static/images/kucun_1.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
               入库明细</p>
                   <div class="row ml-2">
                     <div class="col-lg-9">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font hei" v-model="searchForm.ypmc" @keyup="ypmc">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        生产厂家:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keyup="cdmc">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keyup="ph">
                                  </div> 
                                  </div>   
                               </div>
                              
                                 </div>
                                   
                             </div>
                               
                          </div>

                       </div>
                        <div class="col-lg-3">
                          <div class="row ml-lg-5">            
                                 <button class="bg-info button_zi hei" style="width:40%;" @click="Search()">开始查询</button>
                             
                      </div>
                  </div>
                </div> 
                   
           <table v-if="searchData.length>0"  class="table table-striped table-hover" ref="print">
               <thead>
                     <tr style="white-space: nowrap;">
                      <th>药品名称</th>
                        <th>产地</th>
                        <th>规格</th>
                        <th>单位</th>
                        <th>包装</th>
                        <th>批号</th>
                        <th>数量</th>
                        <th>入库日期</th>
                      </tr>
               </thead>
               <tbody>
                    <tr v-for="(item,index) in searchData" :key="index">
                             <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.addr}}</td>
                              <td>{{item.spec}}</td>
                              <td>{{item.unit}}</td>
                              <td>{{item.package}}</td>
                              <td>{{item.batchNo}}</td>
                              <td>{{item.num}}</td>
                              <td>{{item.date | formatUTC}}</td>    
                  </tr>
               </tbody>

            </table>
            <table class="table table-striped table-hover" ref="print" v-else>
                    <thead>
                      <tr style="white-space: nowrap;">
                        <th>药品名称</th>
                        <th>产地</th>
                        <th>规格</th>
                        <th>单位</th>
                        <th>包装</th>
                        <th>批号</th>
                        <th>数量</th>
                        <th>入库日期</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index">
                              <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.addr}}</td>
                              <td>{{item.spec}}</td>
                              <td>{{item.unit}}</td>
                              <td>{{item.package}}</td>
                              <td>{{item.batchNo}}</td>
                              <td>{{item.num}}</td>
                              <td>{{item.date | formatUTC}}</td>
                            
                      </tr>
                    </tbody>
                  </table>
                  <!-- 分页 -->
      <nav aria-label="Page navigation" style="text-align:center;">
      <ul class="pagination">
        <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
          <a aria-label="Previous" class="page-link">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                @click="curPage(index)">
                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                            </li>
                                            
        <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
          <a aria-label="Next" class="page-link" >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
          <li class="ml-5">
            <span class="d-block mt-2">
              总共有
              <span style="color:green;font-size:20px">{{Record}}</span>
              条数据
            </span>
          </li>
      </ul>
    </nav>
</div> 
              

</div>        <!-- container -->
    
                <div>
                  <transition name="fade">
                           <loading v-if="isLoading"></loading>
                  </transition>
                </div>
  <!-- Footer -->
         <mfooter></mfooter>
     </div>
</template>
<script>
import mheade from '../../components/vender/Heade.vue'
import mfooter from '../../components/Footer.vue'
import Loading from '../../components/Loading.vue'
export default {
      name: 'SaleQuery',
    data () {
      return {
        searchForm: {
          ypmc: '',
          cdmc: '',
          ph: ''
    
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: true,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1 //当前页码
      }
    },
    components:{
        mheade,
        mfooter,
        Loading
    },
    computed:{
       
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
  
                return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
},

methods: {
    //验证
         ypmc:function(){
              let reg1=/^[\u4e00-\u9fa5]{0,}$/;
               if(!reg1.test(this.searchForm.ypmc)){
                     $("#ypmc").removeClass("d-none")
               }
               else{
                    $("#ypmc").addClass("d-none")
               }
          },
          ph:function(){
               let reg2=/^[0-9]*$/;
               if(!reg2.test(this.searchForm.ph)){
                     $("#ph").removeClass("d-none")
               }
               else{
                    $("#ph").addClass("d-none")
               }
          },
          cdmc:function(){
                let reg3=/^[\u4e00-\u9fa5]{0,}$/;
                if(!reg3.test(this.searchForm.cdmc)){
                     $("#cdmc").removeClass("d-none")
               }
               else{
                     $("#cdmc").addClass("d-none")
               }
          },
     
    onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].drugName;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].drugName;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].addr
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].addr;
          }  
      },

      getFactoryInStore: async function (PageIndex) {
          this.isLoading=true;
          this.PageNo=PageIndex || this.PageNo
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'FactoryInStore',
          obj: JSON.stringify({
             PageIndex,
             PageSize:20
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.tableData = obj.rows
          this.Pcount = obj.pcount
          this.Record = obj.record
          this.isLoading=false
          /*
          {
          drugName: '白癜风丸',
          productFactory: '吉林省银诺克药业有限公司',
          spec: '36s',
          batchNum: '20190204',
          unit: '盒',
          price: 5.5,

        }
          * */
        }
      },
      //搜索
        Search: async function (PageIndex) {

        const that = this
        that.isLoading=true;
        // search 是 v-model="search" 的 search
        if(!PageIndex){PageIndex=1}
        that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'FactoryInStore',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DrugName: that.searchForm.ypmc,
            BatchNo: that.searchForm.ph,
            Addr: that.searchForm.cdmc,
          })
        })
        // console.log(res)
        if(res.isok){
              const obj = res.data
              that.searchData = obj.rows
              that.Pcount = obj.pcount
              that.Record = obj.record
              that.isLoading=false;
              if(obj.pcount==0){
                alert('没有符合条件的信息')
              }
              
        }
        },


     curPage: function (index) {
         if(this.searchData.length>0){
            this.Search(index)
         }
         else{
           this.getFactoryInStore(index)
         }
      },
      //上一页
      prePage: function () {
        if (this.PageNo > 1) {
          this.PageNo--;
           if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getFactoryInStore(this.PageNo);
          }
        }
      },
      //下一页
      nextPage: function () {
        if (this.PageNo < this.Pcount) {
          this.PageNo++;
          if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getFactoryInStore(this.PageNo);
          }
        }
      },
      //搜索功能
    
      
     // 打印
    start_print(){
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
    }

    },
     created () {
        this.getFactoryInStore();
        
        
      
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.hei{
  height:1.5rem;
}
.font_yz{
  font-size:1px;
  color:red;
}
 .button_zi{
      border-radius: 1px;
      border:none;
      color:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/vender/FactoryEnterDetail.vue